import { CurrencyPipe } from '@angular/common';
import { inject, Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'appCurrencyPipe'
})
export class AppCurrencyPipe implements PipeTransform {
  
  private currencyPipe = inject(CurrencyPipe);

  transform(value: number): string {
    if (value == null) {
      return null;
    }

    const isInteger = Number.isInteger(value);
    const format = isInteger ? '1.0-0' : '1.2-2';

    // currencyCode: EUR, USD, etc.
    // 'symbol': 'symbol-narrow' o 'code'
    // format: pattern
    return this.currencyPipe.transform(value, 'EUR', 'symbol', format);
  }

}
